import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  DepartmentHero,
  DepartmentAbout,
  DepartmentCTA,
  DepartmentServices,
} from '../components/departments';
import Counter from '../components/Counter';
import Testimonials from '../components/Testimonials';

// Icônes
import {
  faGears,
  faBuilding,
  faNetworkWired,
  faBolt,
  faShieldAlt,
  faUsers,
  faFileAlt,
  faFolder,
  faAward,
} from '@fortawesome/free-solid-svg-icons';

// Images (à importer ou à remplacer par des chemins)
import chefImage from '../images/DGE_450x500.webp';
import logoElectrique from '../images/logo ATC génie électrique.webp';
import autoIndusImg from '../images/Automatisme_industriel_458x500.webp';
import batIntelImg from '../images/batiment_intelligents_458x500.webp';
import reseauIoTImg from '../images/IOT_458x500_458x500.webp';
import energieImg from '../images/GESTION_ELECTRIQUE_458x500.webp';
import securiteImg from '../images/SECURITER_458x500.webp';
import temoin1 from '../images/TEMOIN1_GE_80X80.webp';
import temoin2 from '../images/TEMOIN2_GE_80X80.webp';
import temoin3 from '../images/TEMOIN3_GE_80X80.webp';
import monImage from '../images/GENIE_electrique_1920x780.webp';
import ctaBackground from '../images/FORMATION_GENIE_ELECT_900x500.webp';

const ElectricalEngineering = () => {
  const { t } = useTranslation();

  // Données pour le composant Counter (statistiques)
  const statsData = [
    { icon: faUsers, target: 3, label: t('clients_satisfaits'), suffix: '+', color: '#4fc3f7' },
    { icon: faFileAlt, target: 0, label: t('nbre_formations'), suffix: '+', color: '#90ee90' },
    { icon: faFolder, target: 3, label: t('nbre_projets'), suffix: '+', color: '#ffb74d' },
    { icon: faAward, target: 2, label: t('annees_experience'), suffix: '+', color: '#f06292' },
  ];

  // Données pour les témoignages
  const testimonialsData = [
    {
      text: t('msg_temoin1_depart_GE'),
      name: 'DEFFO PIERRE',
      role: t('role_temoin1_depart_GE'),
      image: temoin1,
    },
    {
      text: t('msg_temoin2_depart_GE'),
      name: 'Fatou Diop',
      role: t('role_temoin2_depart_GE'),
      image: temoin2,
    },
    {
      text: t('msg_temoin3_depart_GE'),
      name: 'Jean Koffi',
      role: t('role_temoin3_depart_GE'),
      image: temoin3,
    },
  ];

  // Compétences du département (tags)
  const skills = [
    { label: t('skill1_departement_electriq'), color: '#c8a02b' },
    { label: t('skill2_departement_electriq'), color: '#c8a02b' },
    { label: t('skill3_departement_electriq'), color: '#c8a02b' },
    { label: t('skill4_departement_electriq'), color: '#c8a02b' },
  ];

  return (
    <div className="electrical-engineering-page">
      {/* Hero */}
      <DepartmentHero
        title={t('electriq_card_titre_Notre_expertise')}
        subtitle={t('sous_titre_departement_electriq')}
        breadcrumb={[
          { label: t('msg_Departement_electricite') },
        ]}
        background={monImage}
        badge="Services / Génie Électrique"
        height="large"
      />

      {/* About */}
      <DepartmentAbout
        chefImage={chefImage}
        chefName="M. Mohamed"
        chefRole={t('CHEF_departement_info')}
        chefSocial={[
          { icon: 'facebook', url: 'https://www.facebook.com/mohamed.njindjou' },
          { icon: 'whatsapp', url: 'https://wa.me/237679417101' },
          { icon: 'linkedin', url: 'https://www.linkedin.com/in/mohamed-koagne' },
        ]}
        logoImage={logoElectrique}
        title={t('titre_departement_electriq')}
        subtitle={t('sous_titre_departement_electriq')}
        description={t('msg_departement_electriq')}
        skills={skills}
      />

      {/* CTA */}
      <DepartmentCTA
        title={t('titre_devis_departement_info')}
        subtitle={t('sous_titre_devis_departement_info')}
        primaryButton={{ label: t('btn_devis_departement_info'), link: '/contact' }} 
        secondaryButton={{ label: t('btn_FORMATION_devis_departement_info'), link: '/formation' }}
        backgroundImage={ctaBackground} 
        badge=" Solutions ATC"
        formationLink="/formation/electrique" 
      />

      {/* Services */}
      <DepartmentServices
        title={t('titre_service_departement_info')}
        subtitle={t('sous_titre_service_departement_info')}
        services={[
          {
            title: t('auto_indus_titre_service_departement_ge'),
            icon: faGears,
            color: '#0066cc',
            frontDesc: t('auto_indus_msg2_service_departement_ge'),
            backDesc: t('auto_indus_msg1_service_departement_ge'),
            image: autoIndusImg,
            overlayColor: 'rgba(0, 102, 204, 0.66)',
          },
          {
            title: t('bat_intel_titre_service_departement_ge'),
            icon: faBuilding,
            color: '#c8a02b',
            frontDesc: t('bat_intel_msg2_service_departement_ge'),
            backDesc: t('bat_intel_msg1_service_departement_ge'),
            image: batIntelImg,
            overlayColor: 'rgba(200, 160, 43, 0.66)',
          },
          {
            title: t('reseau_iot_titre_service_departement_ge'),
            icon: faNetworkWired,
            color: '#107a3e',
            frontDesc: t('reseau_iot_msg2_service_departement_ge'),
            backDesc: t('reseau_iot_msg1_service_departement_ge'),
            image: reseauIoTImg,
            overlayColor: 'rgba(16, 122, 62, 0.66)',
          },
          {
            title: t('energie_titre_service_departement_ge'),
            icon: faBolt,
            color: '#6b3fa0',
            frontDesc: t('energie_msg2_service_departement_ge'),
            backDesc: t('energie_msg1_service_departement_ge'),
            image: energieImg,
            overlayColor: 'rgba(107, 63, 160, 0.66)',
          },
          {
            title: t('securite_titre_service_departement_ge'),
            icon: faShieldAlt,
            color: '#e67e22',
            frontDesc: t('securite_msg2_service_departement_ge'),
            backDesc: t('securite_msg1_service_departement_ge'),
            image: securiteImg,
            overlayColor: 'rgba(230, 126, 34, 0.66)',
          },
        ]}
      />

      {/* Statistiques */}
      <Counter stats={statsData} isDark={true} showBar={true} />

      {/* Témoignages */}
      <Testimonials
        title={t('temoignage')}
        subtitle={t('sous_titre_temoignage')}
        testimonials={testimonialsData}
        isDark={false}
      />
    </div>
  );
};

export default ElectricalEngineering;